<template>
    <div>
        <div class="tit_page d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-start justify-content-lg-end mob">
                <h1>Estatísticas <span class="separador"></span></h1>
                <ul>
                    <li>
                        <router-link to="/investimentos/estatisticas/">Minhas estatísticas</router-link>
                    </li>
                    <li v-if="showMeInfo()">
                        <router-link to="/investimentos/estatisticas/estatisticas-da-plataforma/investidores">Estatísticas da plataforma</router-link>
                    </li>
                </ul>
            </div>
            <div class="back">
                <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                    <i class="back">&nbsp;</i> <span>Voltar</span>
                </a>
            </div>
        </div>

        <div class="menu-mob">
            <ul>
                <li>
                    <router-link to="/investimentos/estatisticas/">Minhas estatísticas</router-link>
                </li>
                <li v-if="showMeInfo()">
                    <router-link to="/investimentos/estatisticas/estatisticas-da-plataforma/investidores">Estatísticas da plataforma</router-link>
                </li>
            </ul>
        </div>

        <router-view  />

    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutation-types.js'
    export default {
        data() {
            return {
                User: null
            }
        },
        methods:{
            showMeInfo() {
                // Verifica se o investidor tem acesso as estatísticas
                // Verifica cadastro completo 
                if(this.User.hasinvestor && this.User.hassuitability && this.User.investor.Status == "APROVADO") {
                    return true
                } else {
                    return false
                }
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/estatisticas',
                    title: 'Estatisticas',
                })
            },
        },
        beforeCreate(){
            this.$store.dispatch('updateUser')
        },
        async created(){
            if(this.$store.state.currentUser.investor != null){
                if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined')
                    window.location.href="#/"
            }
            
            this.User = this.$store.state.currentUser;

            //tagueamento GA
            await this.taggingGA();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    .tit_page {
        border-bottom: 1px solid #ddd;
        margin-bottom: 20px;

        h1 {
            padding-bottom: 20px;
            display: flex;
            align-items: center;
        }

        .back {
            margin-bottom: 13px;
        }

        .separador {
            display: block;
            width: 13px;
            height: 22px;
            margin: 0 8px 0 25px;
            background: url(/static/assets/images/icon-arrow.svg) no-repeat center center;
            background-size: 13px auto;
        }

        ul {
            position: relative;
            padding:0px;
            margin:5px 0 0 0;
            bottom: -1px;
            li {
                display: inline-block;
                margin: 0 15px;

                a {
                    @include font-size(18px);
                    color: #999;
                    font-weight: bold;

                    &.router-link-active {
                        color: #999;
                        @include separador(100%, 1px, 28px, 0px, 0, auto, #ddd);

                        &:hover {
                            color: #000;
                        }
                    }

                    &.router-link-exact-active {
                        color: #000;
                        
                        @include separador(100%, 1px, 28px, 0px, 0, auto, $c3);
                    }
                }
            }
        }

        // MOBILE
        @include xs {
            margin-bottom: 10px;
            .d-flex {
                flex-direction: column!important;
            }

            h1 {
                @include font-size(24px);
                padding-bottom: 8px;

                span {
                    display: none!important;
                }
            }
            .separador {
                width: 8px;
                height: 20px;
                margin: 0 8px;
                background-size: 8px auto;
            }

            .back {
                margin-bottom: 8px;
            }

            .mob {
                ul {
                    display: none;
                }
            }
        }

        // DESKTOP
        @include ds {
            h1 {
                padding-bottom: 20px;
            }

            .separador {
                width: 8px;
                height: 17px;
                margin: 8px 0 0 18px;
                background-size: 8px auto;
            }

            .back {
                margin-bottom: 10px;
            }
 
            ul li {
                margin: 0 10px;
                a {
                    @include font-size(14px);

                    &.router-link-active {
                        @include separador(100%, 1px, 19px, 0px, 0, auto, #ddd);
                    }

                    &.router-link-exact-active {
                        @include separador(100%, 1px, 19px, 0px, 0, auto, $c3);
                    }
                }
            }
        }
    }

    // MENU MOBILE
    .menu-mob {
        display: none;

        @include ds {
            display: none;
        }

        @include xs {
            display: inherit!important;

            ul {
                border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
                li {
                    a {
                        @include font-size(16px);
                        color: #999;
                        font-weight: bold;

                        &.router-link-active {
                            color: #999;

                            &:hover {
                                color: #000;
                            }
                        }

                        &.router-link-exact-active {
                            color: #000;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Statistics.vue